import { useTranslation } from 'react-i18next';
import type { ImportSummary } from '@/api/clientImports/clientImportsApi.types';
import { Card } from '@/components/ui/card';
import { Icon } from '@/components/common/Icon';
import { cn } from '@/lib/utils';

interface ImportSummaryBarProps {
  summary: ImportSummary;
}

export function ImportSummaryBar({ summary }: ImportSummaryBarProps) {
  const { t } = useTranslation('clientImport');

  return (
    <Card padding="sm" className="flex flex-wrap items-center justify-between gap-3">
      <div className="flex flex-wrap items-center gap-4 text-sm text-zooindigo">
        <span>{t('summary.rows', { count: summary.totalRows })}</span>
        <span>{t('summary.clients', { count: summary.clientCount })}</span>
        <span>{t('summary.pets', { count: summary.petCount })}</span>
        <span className={summary.errorCount > 0 ? 'text-zooerrortext font-bold' : 'text-zoomuted'}>
          {t('summary.errors', { count: summary.errorCount })}
        </span>
        <span className={summary.warningCount > 0 ? 'text-zoowarningtext font-bold' : 'text-zoomuted'}>
          {t('summary.warnings', { count: summary.warningCount })}
        </span>
      </div>
      <div
        className={cn(
          'flex items-center gap-1.5 text-sm font-bold',
          summary.isCommittable === true ? 'text-zoosuccesstext' : 'text-zooerrortext'
        )}
      >
        <Icon name={summary.isCommittable === true ? 'CheckCircle' : 'AlertCircle'} />
        {summary.isCommittable === true
          ? t('summary.readyToImport')
          : t('summary.fixErrorsBeforeImport')}
      </div>
    </Card>
  );
}
